<h2 mat-dialog-title>{{ editMode ? ('EDITREFERENCE' | translate) : ('ADDREFERENCE' | translate) }}</h2>

<mat-dialog-content>
  <form [formGroup]="Form">
    
    <mat-form-field appearance="fill" class="form-field">
      <mat-label>{{ 'NAME' | translate }}</mat-label>
      <input matInput formControlName="firstName" placeholder="{{ 'ENTERNAME' | translate }}" />
      <mat-error *ngIf="Form.get('firstName')?.hasError('required')">
        {{ 'REQUIREDFIELD' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="form-field">
        <mat-label>{{ 'FIRSTLASTNAME' | translate }}</mat-label>
        <input matInput formControlName="firstLastname" placeholder="{{ 'ENTERFIRSTLASTNAME' | translate }}" />
        <mat-error *ngIf="Form.get('firstLastname')?.hasError('required')">
          {{ 'REQUIREDFIELD' | translate }}
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="form-field">
        <mat-label>{{ 'SECONDLASTNAME' | translate }}</mat-label>
        <input matInput formControlName="secondLastname" placeholder="{{ 'ENTERSECONDLASTNAME' | translate }}" />
        <mat-error *ngIf="Form.get('secondLastname')?.hasError('required')">
          {{ 'REQUIREDFIELD' | translate }}
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="form-field">
        <mat-label>{{ 'AGE' | translate }}</mat-label>
        <input matInput formControlName="age" placeholder="{{ 'ENTERAGE' | translate }}" />
        <mat-error *ngIf="Form.get('age')?.hasError('required')">
          {{ 'REQUIREDFIELD' | translate }}
        </mat-error>
    </mat-form-field>

    <!-- Dropdown para seleccionar país -->
    <mat-form-field appearance="fill" class="form-field">
      <mat-label>{{ 'COUNTRY' | translate }}</mat-label>
      <mat-select formControlName="countryId" (selectionChange)="onCountryChange($event.value)" placeholder="{{ 'SELECTOPTION' | translate }}">
        <mat-option *ngFor="let country of countries" [value]="country.id">
          {{ country.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="Form.get('countryId')?.hasError('required')">
        {{ 'REQUIREDFIELD' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="form-field">
        <mat-label>{{ 'STATE' | translate }}</mat-label>
        <mat-select formControlName="state_Id" placeholder="{{ 'SELECTOPTION' | translate }}">
          <mat-option *ngFor="let state of states" [value]="state.id">
            {{ state.statename }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="Form.get('state_Id')?.hasError('required')">
          {{ 'REQUIREDFIELD' | translate }}
        </mat-error>
    </mat-form-field> 

    <mat-form-field appearance="fill" class="form-field">
        <mat-label>{{ 'OCCUPATION' | translate }}</mat-label>
        <mat-select formControlName="occupation_Id" placeholder="{{ 'SELECTOPTION' | translate }}">
          <mat-option *ngFor="let element of occupations" [value]="element.id">
            {{ element.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="Form.get('occupation_Id')?.hasError('required')">
          {{ 'REQUIREDFIELD' | translate }}
        </mat-error>
    </mat-form-field>  
    
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-raised-button color="primary" [disabled]="Form.invalid" (click)="onSubmit()">{{ this.editMode ? 'Editar' : 'Agregar' }}</button>
</mat-dialog-actions>
